import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DoubleArrowsExpand = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4999 7.00003C13.4999 7.27617 13.7237 7.50003 13.9999 7.50004C14.276 7.50004 14.4999 7.27619 14.4999 7.00005L14.5 2.49995C14.5 2.36734 14.4473 2.24016 14.3535 2.14639C14.2598 2.05262 14.1326 1.99994 14 1.99994H9.49989C9.22375 1.99994 8.99989 2.2238 8.99989 2.49994C8.99989 2.77608 9.22375 2.99994 9.49989 2.99994L12.7929 2.99994L9.14634 6.64647C8.95108 6.84174 8.95108 7.15832 9.14634 7.35358C9.3416 7.54884 9.65818 7.54884 9.85344 7.35358L13.5 3.70707L13.4999 7.00003ZM3.50017 8.99991C3.50017 8.72376 3.27632 8.4999 3.00018 8.4999C2.72403 8.4999 2.50017 8.72375 2.50017 8.9999L2.50012 13.5001C2.50012 13.6327 2.5528 13.7599 2.64657 13.8536C2.74034 13.9474 2.86751 14.0001 3.00012 14.0001H7.50031C7.77645 14.0001 8.00031 13.7762 8.00031 13.5001C8.00031 13.2239 7.77645 13.0001 7.50031 13.0001H4.20723L7.85386 9.35345C8.04912 9.15819 8.04912 8.84161 7.85386 8.64635C7.6586 8.45108 7.34202 8.45108 7.14676 8.64635L3.50013 12.293L3.50017 8.99991Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DoubleArrowsExpand
